module.exports = __webpack_public_path__ + "static/media/checkace.15845129.svg";